<template>
  <b-row align-v="center" v-if="fieldName && done">
    <b-col cols="11">
      <AttributeDisplay
        :fieldName="fieldName"
        :fieldType="fieldType"
        :props="$props"
      >
      </AttributeDisplay>
    </b-col>
    <b-col cols="1">
      <b-col cols="5">
        <v-tooltip right>
          <template v-slot:activator="{ edit }">
            <b-icon v-on="edit" icon="wrench" @click="done = false"></b-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </b-col>
      <b-col cols="5">
        <v-tooltip right>
          <template v-slot:activator="{ remove }">
            <b-icon v-on="remove" icon="x" @click="$emit('clear')"></b-icon>
          </template>
          <span>Remove</span>
        </v-tooltip>
      </b-col>
    </b-col>
  </b-row>
  <div v-else>
    <b-form-select
      v-model="selected"
      :options="formOptions"
      size="md"
      class="mt-3"
    >
      <template v-slot:first>
        <b-form-select-option :value="null" disabled selected
          >-- Please select an option --</b-form-select-option
        >
      </template>
    </b-form-select>

    <b-jumbotron
      v-if="selected && !done"
      :lead="`Set the properties for your custom ${fieldType} field`"
    >
      <b-input-group class="attribute" size="md" prepend="Name">
        <b-form-input
          :name="fieldName"
          :value="fieldName"
          :state="validateState('fieldName')"
          aria-describedby="fieldname-feedback"
          @input="$emit('update:fieldName', $event)"
        />
        <b-form-invalid-feedback v-if="$v.$props.fieldName.$anyError"
          >A field name is required.</b-form-invalid-feedback
        >
      </b-input-group>
      <b-row>
        <FormElementAttributeConfig
          v-for="attribute in selected.attributes"
          :key="attribute.name"
          v-bind="attribute"
          @change="updateParent"
        ></FormElementAttributeConfig>
      </b-row>
      <b-button variant="primary" @click="checkProps">Done</b-button>
    </b-jumbotron>
  </div>
</template>

<script>
import FormElementAttributeConfig from "@/components/form-elements/generators/FormElementAttributeConfig";
import AttributeDisplay from "@/components/form-elements/generators/FormElementAttributeDisplay";
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";
import { required } from "vuelidate/lib/validators";

export default {
  components: { FormElementAttributeConfig, AttributeDisplay },
  data() {
    return {
      selected: null,
      elements: [],
      done: Boolean
    };
  },
  props: {
    fieldName: String,
    fieldType: String,
    type: String,
    required: Boolean,
    placeHolder: String,
    label: String,
    checkedValue: String,
    uncheckedValue: String,
    min: { type: [Number, Date] },
    max: { type: [Number, Date] },
    format: String,
    defaultValue: { type: [String, Number, Boolean, Date] },
    step: Number,
    options: Array,
    rows: Number,
    maxRows: Number,
    isSet: Boolean
  },
  validations: {
    $props: {
      fieldName: {
        required
      }
    }
  },
  methods: {
    async getCustomFields() {
      let result = (
        await API.graphql(
          graphqlOperation(queries.getAllFormElementConfigurations)
        )
      ).data.getAllFormElementConfigurations;
      this.elements = this.elements.concat(
        result.map(e => {
          if (typeof e.attributes === "string")
            e.attributes = JSON.parse(e.attributes);
          e.attributes.sort((a, b) => (a.type > b.type ? 1 : -1));
          return e;
        })
      );
    },
    updateParent(change) {
      this.$emit(`update:${change.name}`, change.value);
    },
    checkProps() {
      this.$v.$props.$touch();
      if (this.$v.$props.$anyError) {
        return;
      }
      this.done = true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.$props[name];
      return $dirty ? !$error : null;
    }
  },
  computed: {
    formOptions() {
      return this.elements?.length > 0
        ? this.elements.map(function(element) {
            return { text: element.name, value: element };
          })
        : [{ text: "No options found", value: null }];
    }
  },
  watch: {
    selected(value) {
      this.$emit("update:fieldType", value.name);
    },
    elements(value) {
      var items = JSON.parse(JSON.stringify(value));
      if (this.isSet) {
        const vm = this;
        var found = items.find(e => {
          return e.name == vm.fieldType;
        });
        this.selected = found;
      }
    },
    done(value) {
      if (value) {
        this.$emit("done");
      }
    }
  },
  async created() {
    await this.getCustomFields();
    this.done = this.isSet;
  }
};
</script>

<style></style>
